import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { OrgMemberProposal } from '@/hooks/admin/member/use-pending-member-proposals';

type RemoveMemberArg = {
  removingUserId: string;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: RemoveMemberArg }
): Promise<OrgMemberProposal> => {
  const { removingUserId } = arg;
  return await denApi.post<OrgMemberProposal, { removingUserId: string }>(
    `admin/organization/member-proposals/remove`,
    { removingUserId }
  );
};

export function useRemoveMember(
  swrOptions?: SWRMutationConfiguration<
    OrgMemberProposal,
    Error,
    string,
    RemoveMemberArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    OrgMemberProposal,
    Error,
    string,
    RemoveMemberArg
  >('admin/organization/member-proposals/remove', fetcher, swrOptions);

  return { removeMember: trigger, isLoading: isMutating, error };
}
